import { CONSTANTS } from 'client/utils/constants';
import { Tooltip,Label } from '../../../../CommonComponents';
import './RequestDetail.scss'

const RequestDetail = (props: any) => {
  const transferOrderByIdData = props?.transferOrderByIdData;

  return (
    <>
      <div className="borderCard-assetApproval pendingApprovalOrder">
        <div>
          <Label data-attribute="RequestDetail_Default_Label">Current Branch</Label>
          <Tooltip content={transferOrderByIdData?.costCenter || '-'} data-attribute="RequestDetail_Default_Tooltip">
            <div className="content" >{transferOrderByIdData?.costCenter || '-'}</div>
          </Tooltip>
        </div>
        {transferOrderByIdData?.orderRequestType != CONSTANTS.AFEREQUEST && <div>
          <Label data-attribute="RequestDetail_Default_Label_2">Qty</Label>
          <Tooltip content={transferOrderByIdData?.quantity || '-'} data-attribute="RequestDetail_Default_Tooltip_2">
            <div className="content" >{transferOrderByIdData?.quantity || '-'}</div>
          </Tooltip>
        </div>}
        <div>
          <Label data-attribute="RequestDetail_Default_Label_3">Requested By</Label>
          <Tooltip content={transferOrderByIdData?.requestedBy != " " ? transferOrderByIdData?.requestedBy : '-'} data-attribute="RequestDetail_Default_Tooltip_3">
            <div className="content" >{transferOrderByIdData?.requestedBy != " " ? transferOrderByIdData?.requestedBy : '-'}</div>
          </Tooltip>
        </div>
        <div>
          <Label data-attribute="RequestDetail_Default_Label_4">Assigned To</Label>
          <Tooltip content={transferOrderByIdData?.assignedTo ?? "-"} data-attribute="RequestDetail_Default_Tooltip_4">
            <div className="content">{transferOrderByIdData?.assignedTo ?? "-"}</div>
          </Tooltip>
        </div>
        <div>
          <Label data-attribute="RequestDetail_Default_Label_5">Pre-Authorized</Label>
          <Tooltip content={transferOrderByIdData?.isApprovalOverride ? "Yes" : "No"} data-attribute="RequestDetail_Default_Tooltip_5">
            <div className="content">{transferOrderByIdData?.isApprovalOverride ? "Yes" : "No"}</div>
          </Tooltip>
        </div>
      </div>
    </>
  )
}

export default RequestDetail;